import { memo, useCallback } from 'react';
import { SelectableChip } from '@aimsos/ui';

/**
 * One counter chip (All / New / Updates / Errors) of the review toolbar.
 *
 * @param {object} props
 * @param {string} props.status Status filter value it selects.
 * @param {boolean} props.selected
 * @param {string} props.label Translated text with the count.
 * @param {(change: { status: string }) => void} props.onSelect
 */
function StatusChip({ status, selected, label, onSelect }) {
  const handleClick = useCallback(() => onSelect({ status }), [onSelect, status]);
  return (
    <SelectableChip selected={selected} onClick={handleClick}>
      {label}
    </SelectableChip>
  );
}

export default memo(StatusChip);
